import { ToastProvider } from './components/primitives';
import { AppRoutes } from './routes/routes';

export default function App() {
  return (
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  );
}
